import { tss } from "tss-react/mui"; import { DEFAULT_LEFT_PADDING, DEFAULT_RIGHT_PADDING, MOBILE_LEFT_PADDING, MOBILE_RIGHT_PADDING, WINDOW_MAX_WIDTH } from "../../../layout/Layout.styles";

export const useStyles = tss.create(({ theme }) => ({
	root: {
		position: 'relative',
	},
	container: {
		margin: '0 auto',
		maxWidth: WINDOW_MAX_WIDTH,
		paddingLeft: DEFAULT_LEFT_PADDING,
		paddingRight: DEFAULT_RIGHT_PADDING,
		paddingBottom: 16,
		overflow: 'hidden',
		[theme.breakpoints.down('md')]: {
			paddingLeft: MOBILE_LEFT_PADDING,
			paddingRight: MOBILE_RIGHT_PADDING,
			paddingBottom: 12,
		}
	},
	content: {
		color: '#242C37',
		fontSize: 16,
		fontWeight: 400,
		lineHeight: '32px',
		letterSpacing: '0.15px',
		'& *': {
			color: 'inherit',
		},
		"& p, h2": {
			fontFamily: 'Circular Std',
			fontSize: "16px !important",
		},
		'& a': {
			color: theme.palette.primary.main,
		},
		"& img": {
			width: '100% !important'
		},
		[theme.breakpoints.down('md')]: {
			fontSize: 16,
			lineHeight: '32px',
			letterSpacing: '0.15px',
		}
	}
}))